import { formatClock } from "./format";

const PILL =
  "pointer-events-none absolute z-10 whitespace-nowrap rounded border bg-background px-1.5 py-0.5 font-mono text-[10px] text-foreground/80 shadow-xs";

/** Single timecode that follows the cursor (sits just above it). `x`/`y` are px relative to the track. */
export function HoverStamp({ x, y, time }: { x: number; y: number; time: number }) {
  return (
    <div className={`${PILL} -translate-x-1/2 -translate-y-full`} style={{ left: x, top: y - 8 }}>
      {formatClock(time)}
    </div>
  );
}

/** Read-only "from–to · duration" tag centered above a rubber-band region (positioned by percent). */
export function RangeTag({ leftPct, from, to }: { leftPct: number; from: number; to: number }) {
  return (
    <div className={`${PILL} -top-8 -translate-x-1/2`} style={{ left: `${leftPct}%` }}>
      {formatClock(from)}–{formatClock(to)} · {formatClock(to - from)}
    </div>
  );
}
